import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
    UserData,
    getTemplateList,
    GetEquipmentTemplate,
    GetPricingEquipmentTemplateList,
    GetPricingEquipmentTemplate,
    DeletePricingTemplate,
    GetAllOrganizationsSingleCall,
    getPricingTemplate,
    GetOrganizationById,
} from "../../api";
import Header from "../preapps/Header";
import Notifications from "react-notify-toast";
import "../../../sass/residuals.scss";
import "./pricing-equipment.scss";
import PricingTemplate from "../organizations/edit-organization/pricing-template/pricing-template";
import AddPricingTemplate from "../modals/add-pricing-template/add-pricing-template";
import EquipmentTemplate from "../organizations/edit-organization/equipment-template/equipment-template";
import PricingEquipmentTemplate from "../organizations/edit-organization/pricing-equipment-template/pricing-equipment-template";
import { getAlertPopUp } from "../helper/helper";

export default class PricingEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            pricingEquipmentTemplateCount: 0,
            equipmentTemplateCount: 0,
            templateCount: 0,
            templateList: [],
            showAddTemplate: false,
            selectedBranch: null,
            selectedTemplate: null,
            showTemplate: false,
            org_options: [],
            isPcAdmin: false,
            user_options: [],
            selected_org_id: "",
            selected_user_id: "",
            system_level: false,
            searchKeyword: "",
            equipmentTemplateList: {},
            pricingEquipmentTemplateList: {},
            showSpinner: false,
            parentCmpLoading: true,
        };
    }

    componentDidMount() {
        UserData().then((response) => {
            if (response.organization_id == 1 && response.role == "admin") {
                this.setState({ isPcAdmin: true });
            }
            this.setState({ user: response }, () => {
                this.checkPcAdmin("all");
            });
        });
    }
    getListData() {
        this.getEquipmentTemplateList();
        this.getPricingEquipmentTemplateList();
        this.GetPricingTemplateList();
    }

    editTemplate = (template) => {
        this.setState({
            selectedTemplate: template,
            showTemplate: true,
        });
    };

    getEquipmentTemplateList = () => {
        const searchTerm = {
            organization_id: this.state.selected_user_id
                ? null
                : this.state.selected_org_id,
            user_id: this.state.selected_user_id,
            system_level: this.state.selected_org_id
                ? false
                : this.state.system_level,
            template_name: this.state.searchKeyword,
            showOrgToo: this.state.isPcAdmin
                ? this.state.selected_user_id
                    ? true
                    : false
                : true,
        };
        this.setState({ showSpinner: true });
        GetEquipmentTemplate(searchTerm)
            .then((response) => {
                if (response.success === true) {
                    this.setState(
                        {
                            equipmentTemplateList: response.data,
                            equipmentTemplateCount: response.data.length,
                        },
                        () => {
                            this.setState({ showSpinner: false });
                        },
                    );
                } else {
                    this.setState({
                        showSpinner: false,
                        equipmentTemplateCount: 0,
                        equipmentTemplateList: [],
                    });
                }
            })
            .catch((error) => console.log(error));
    };
    getPricingEquipmentTemplateList = () => {
        const searchTerm = {
            organization_id: this.state.selected_user_id
                ? null
                : this.state.selected_org_id,
            user_id: this.state.selected_user_id,
            system_level: this.state.selected_org_id
                ? false
                : this.state.system_level,
            template_name: this.state.searchKeyword,
            showOrgToo: this.state.isPcAdmin
                ? this.state.selected_user_id
                    ? true
                    : false
                : true,
        };
        this.setState({ showSpinner: true });
        GetPricingEquipmentTemplate(searchTerm)
            .then((response) => {
                if (response.success === true) {
                    this.setState({
                        pricingEquipmentTemplateList: response.data,
                        pricingEquipmentTemplateCount: response.data.length,
                        showSpinner: false,
                    });
                } else {
                    this.setState({
                        showSpinner: false,
                        pricingEquipmentTemplateCount: 0,
                        pricingEquipmentTemplateList: [],
                    });
                }
            })
            .catch((error) => console.log(error));
    };

    GetPricingTemplateList = () => {
        const searchTerm = {
            organization_id: this.state.selected_user_id
                ? null
                : this.state.selected_org_id,
            user_id: this.state.selected_user_id,
            system_level: this.state.selected_org_id
                ? false
                : this.state.system_level,
            template_name: this.state.searchKeyword,
            showOrgToo: this.state.isPcAdmin
                ? this.state.selected_user_id
                    ? true
                    : false
                : true,
        };
        getPricingTemplate(searchTerm).then((response) => {
            if (response.success) {
                this.setState({
                    templateCount: response.data.length,
                    templateList: response.data,
                });
            } else {
                this.setState({
                    showSpinner: false,
                    templateCount: 0,
                    templateList: [],
                });
            }
            this.setState({ parentCmpLoading: false });
        });
    };

    deleteTemplate = (template) => {
        DeletePricingTemplate(template.id)
            .then((response) => {
                if (response.success) {
                    // get updated list of templates
                    this.GetPricingTemplateList();
                    const popup = {
                        title: "Success!",
                        html: "Record removed successfully",
                    };
                    getAlertPopUp(popup);
                } else {
                    const popup = {
                        title: "Error!",
                        html: response.message,
                        error: true,
                    };
                    getAlertPopUp(popup);
                }
            })
            .catch((error) => console.log(error));
    };

    getOrgList() {
        GetAllOrganizationsSingleCall()
            .then((response) => {
                let org_options = [];
                if (response.organization && response.organization.length > 0) {
                    response.organization.forEach((organization) => {
                        org_options.push({
                            label: organization.name,
                            value: organization.id,
                        });
                    });
                }
                this.setState({ org_options: org_options });
            })
            .catch((error) => {});
    }

    checkPcAdmin(filterType) {
        if (this.state.isPcAdmin === true) {
            this.setState({ system_level: true }, () => {
                this.getListData();
                this.getOrgList();
            });
        } else if (
            this.state.isPcAdmin != true &&
            this.state.user.role == "admin"
        ) {
            this.setState(
                {
                    selected_org_id: this.state.user.organization_id,
                    system_level: false,
                },
                () => {
                    this.getListData();
                    this.handleOrgChange(
                        this.state.user.organization_id,
                        filterType,
                    );
                },
            );
        } else {
            this.setState(
                { selected_user_id: this.state.user.id, system_level: false },
                () => {
                    this.getListData();
                },
            );
        }
    }

    handleOrgChange(id, filterType) {
        this.setState(
            { selected_org_id: "", selected_user_id: "", user_options: [] },
            () => {
                this.setState({ selected_org_id: id }, () => {
                    GetOrganizationById(id).then((response) => {
                        let options = [];
                        if (response.users && response.users.length > 0) {
                            response.users.forEach((user) => {
                                options.push({
                                    label: user.name,
                                    value: user.id,
                                });
                            });
                        }
                        this.setState({ user_options: options }, () => {
                            this.filterTemplateByType(filterType);
                        });
                    });
                });
            },
        );
    }
    handleUserChange(id, filterType) {
        this.setState({ selected_user_id: id }, () => {
            this.filterTemplateByType(filterType);
        });
    }
    resetOrgValue(filterType) {
        this.setState({ selected_org_id: "", selected_user_id: "" }, () => {
            this.filterTemplateByType(filterType);
        });
    }
    resetUserValue(filterType) {
        this.setState({ selected_user_id: "" }, () => {
            this.filterTemplateByType(filterType);
        });
    }
    handleSearchKeyChange(value, filterType) {
        this.setState({ searchKeyword: value }, () => {
            this.filterTemplateByType(filterType);
        });
    }
    filterTemplateByType(filterType) {
        switch (filterType) {
            case "pricing":
                this.GetPricingTemplateList();
                break;
            case "equipment":
                this.getEquipmentTemplateList();
                break;
            case "pricingAndEquipment":
                this.getPricingEquipmentTemplateList();
                break;
            case "all":
                this.GetPricingTemplateList();
                this.getEquipmentTemplateList();
                this.getPricingEquipmentTemplateList();
                break;
            default:
                break;
        }
    }

    render() {
        const {
            user,
            showAlert,
            alertHeader,
            alertMessage,
            variant,
            templateList,
            showAddTemplate,
            pricingEquipmentTemplateCount,
            equipmentTemplateCount,
            templateCount,
            selectedTemplate,
            isPcAdmin,
            userData,
        } = this.state;
        const organization_id = null;

        return (
            <div className="website-wrapper application-page residualPage">
                <div className="page-bottom-wrap">
                    <div
                        id="page-content-wrapper"
                        className=""
                        style={{ height: "100vh" }}
                    >
                        <Notifications />
                        {showAlert && (
                            <Alert
                                showAlert={showAlert}
                                heading={alertHeader}
                                message={alertMessage}
                                variant={variant}
                                handleDismissible={() => {
                                    this.setState({ showAlert: false });
                                }}
                            />
                        )}
                        <div className="edit-organization">
                            <div className="row" style={{ height: "100vh" }}>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                                <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                    <div className="editTab">
                                        <Tabs>
                                            <TabList>
                                                <Tab>
                                                    1) Pricing Templates{" "}
                                                    <span>
                                                        {" "}
                                                        ( {templateCount} ){" "}
                                                    </span>
                                                </Tab>
                                                <Tab>
                                                    2) Equipment Templates
                                                    <span>
                                                        {" "}
                                                        ({" "}
                                                        {
                                                            equipmentTemplateCount
                                                        }{" "}
                                                        ){" "}
                                                    </span>
                                                </Tab>
                                                <Tab>
                                                    3) Pricing + Equipment
                                                    Templates
                                                    <span>
                                                        {" "}
                                                        ({" "}
                                                        {
                                                            pricingEquipmentTemplateCount
                                                        }{" "}
                                                        ){" "}
                                                    </span>
                                                </Tab>
                                            </TabList>
                                            <TabPanel>
                                                {this.state.parentCmpLoading !=
                                                    true && (
                                                    <PricingTemplate
                                                        editTemplate={(
                                                            template,
                                                        ) =>
                                                            this.setState({
                                                                selectedTemplate:
                                                                    template,
                                                                showAddTemplate: true,
                                                            })
                                                        }
                                                        deleteTemplate={(evt) =>
                                                            this.deleteTemplate(
                                                                evt,
                                                            )
                                                        }
                                                        showAddTemplateModal={() =>
                                                            this.setState({
                                                                showAddTemplate: true,
                                                                selectedBranch:
                                                                    undefined,
                                                            })
                                                        }
                                                        Template_list={
                                                            templateList
                                                        }
                                                        organizationId={
                                                            organization_id
                                                        }
                                                        updateTemplateCount={(
                                                            evt,
                                                        ) =>
                                                            this.setState({
                                                                templateCount:
                                                                    evt,
                                                            })
                                                        }
                                                        showAddTemplate={
                                                            showAddTemplate
                                                        }
                                                        handleOrgChange={(
                                                            id,
                                                            filterType,
                                                        ) =>
                                                            this.handleOrgChange(
                                                                id,
                                                                filterType,
                                                            )
                                                        }
                                                        handleUserChange={(
                                                            id,
                                                            filterType,
                                                        ) =>
                                                            this.handleUserChange(
                                                                id,
                                                                filterType,
                                                            )
                                                        }
                                                        resetOrgValue={(
                                                            filterType,
                                                        ) =>
                                                            this.resetOrgValue(
                                                                filterType,
                                                            )
                                                        }
                                                        resetUserValue={(
                                                            filterType,
                                                        ) =>
                                                            this.resetUserValue(
                                                                filterType,
                                                            )
                                                        }
                                                        handleSearchKeyChange={(
                                                            id,
                                                            filterType,
                                                        ) =>
                                                            this.handleSearchKeyChange(
                                                                id,
                                                                filterType,
                                                            )
                                                        }
                                                        isPcAdmin={isPcAdmin}
                                                        userData={user}
                                                        org_options={
                                                            this.state
                                                                .org_options
                                                        }
                                                        user_options={
                                                            this.state
                                                                .user_options
                                                        }
                                                        selected_org_id={
                                                            this.state
                                                                .selected_org_id
                                                        }
                                                        selected_user_id={
                                                            this.state
                                                                .selected_user_id
                                                        }
                                                        showSpinner={
                                                            this.state
                                                                .showSpinner
                                                        }
                                                    />
                                                )}
                                                {showAddTemplate && (
                                                    <div>
                                                        <AddPricingTemplate
                                                            selectedTemplate={
                                                                selectedTemplate
                                                            }
                                                            addNewTemplate={(
                                                                evt,
                                                            ) => {
                                                                this.setState({
                                                                    templateList:
                                                                        evt,
                                                                    templateCount:
                                                                        evt.length,
                                                                    selectedTemplate:
                                                                        null,
                                                                });
                                                            }}
                                                            handleClose={() => {
                                                                this.setState({
                                                                    showAddTemplate: false,
                                                                    selectedTemplate:
                                                                        null,
                                                                });
                                                            }}
                                                            updateTemplateList={(
                                                                UpdatedTemplates,
                                                            ) => {
                                                                this.setState({
                                                                    templateList:
                                                                        UpdatedTemplates,
                                                                });
                                                            }}
                                                            show={
                                                                showAddTemplate
                                                            }
                                                            organization_id={
                                                                organization_id
                                                            }
                                                            selected_org_id={
                                                                this.state
                                                                    .selected_org_id
                                                            }
                                                            selected_user_id={
                                                                this.state
                                                                    .selected_user_id
                                                            }
                                                            getTemplateList={() =>
                                                                this.GetPricingTemplateList()
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </TabPanel>
                                            <TabPanel>
                                                <EquipmentTemplate
                                                    organizationId={
                                                        organization_id
                                                    }
                                                    equipmentTemplate={() =>
                                                        this.getEquipmentTemplateList()
                                                    }
                                                    show_null_users={true}
                                                    handleOrgChange={(
                                                        id,
                                                        filterType,
                                                    ) =>
                                                        this.handleOrgChange(
                                                            id,
                                                            filterType,
                                                        )
                                                    }
                                                    handleUserChange={(
                                                        id,
                                                        filterType,
                                                    ) =>
                                                        this.handleUserChange(
                                                            id,
                                                            filterType,
                                                        )
                                                    }
                                                    resetOrgValue={(
                                                        filterType,
                                                    ) =>
                                                        this.resetOrgValue(
                                                            filterType,
                                                        )
                                                    }
                                                    resetUserValue={(
                                                        filterType,
                                                    ) =>
                                                        this.resetUserValue(
                                                            filterType,
                                                        )
                                                    }
                                                    handleSearchKeyChange={(
                                                        id,
                                                        filterType,
                                                    ) =>
                                                        this.handleSearchKeyChange(
                                                            id,
                                                            filterType,
                                                        )
                                                    }
                                                    isPcAdmin={isPcAdmin}
                                                    userData={user}
                                                    org_options={
                                                        this.state.org_options
                                                    }
                                                    user_options={
                                                        this.state.user_options
                                                    }
                                                    selected_org_id={
                                                        this.state
                                                            .selected_org_id
                                                    }
                                                    selected_user_id={
                                                        this.state
                                                            .selected_user_id
                                                    }
                                                    templateList={
                                                        this.state
                                                            .equipmentTemplateList
                                                    }
                                                    showSpinner={
                                                        this.state.showSpinner
                                                    }
                                                />
                                            </TabPanel>
                                            <TabPanel>
                                                <PricingEquipmentTemplate
                                                    pricingEquipmentTemplateList={() =>
                                                        this.getPricingEquipmentTemplateList()
                                                    }
                                                    show_null_users={true}
                                                    organizationId={
                                                        this.state.user
                                                            .organization_id
                                                    }
                                                    save_as_system={true}
                                                    system_level={true}
                                                    handleOrgChange={(
                                                        id,
                                                        filterType,
                                                    ) =>
                                                        this.handleOrgChange(
                                                            id,
                                                            filterType,
                                                        )
                                                    }
                                                    handleUserChange={(
                                                        id,
                                                        filterType,
                                                    ) =>
                                                        this.handleUserChange(
                                                            id,
                                                            filterType,
                                                        )
                                                    }
                                                    resetOrgValue={(
                                                        filterType,
                                                    ) =>
                                                        this.resetOrgValue(
                                                            filterType,
                                                        )
                                                    }
                                                    resetUserValue={(
                                                        filterType,
                                                    ) =>
                                                        this.resetUserValue(
                                                            filterType,
                                                        )
                                                    }
                                                    handleSearchKeyChange={(
                                                        id,
                                                        filterType,
                                                    ) =>
                                                        this.handleSearchKeyChange(
                                                            id,
                                                            filterType,
                                                        )
                                                    }
                                                    isPcAdmin={isPcAdmin}
                                                    userData={user}
                                                    org_options={
                                                        this.state.org_options
                                                    }
                                                    user_options={
                                                        this.state.user_options
                                                    }
                                                    selected_org_id={
                                                        this.state
                                                            .selected_org_id
                                                    }
                                                    selected_user_id={
                                                        this.state
                                                            .selected_user_id
                                                    }
                                                    templateList={
                                                        this.state
                                                            .pricingEquipmentTemplateList
                                                    }
                                                    showSpinner={
                                                        this.state.showSpinner
                                                    }
                                                    equipmentTemplateList={
                                                        this.state
                                                            .equipmentTemplateList
                                                    }
                                                    pricingTemplateList={
                                                        templateList
                                                    }
                                                />
                                            </TabPanel>
                                        </Tabs>
                                    </div>
                                </div>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
